module.exports = __webpack_public_path__ + "static/img/login_bg5.65de557.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/loginSuihua/img/login_bg5.jpg
// module id = UcP4
// module chunks = 183